/* eslint-disable @next/next/no-img-element */
import { Fragment, useState, useRef, useEffect } from "react";
import { Dialog, Transition, Listbox } from "@headlessui/react";
import {
    RectangleStackIcon,
    ChevronUpDownIcon,
    ChevronRightIcon,
} from "@heroicons/react/20/solid";

import modes from "./CreateModes";

const collections = [
    {
        name: "Flat Circles",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4a8ba709f30ecf30dd39/xxs",
    },
    {
        name: "Olden Vibes",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/46ea875703f94a097712/xxs",
    },
    {
        name: "Soft Blobs",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4b1abd7544706da13974/xxs",
    },
    {
        name: "Raw Forms",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4699823fa952ca211672/xxs",
    },
    {
        name: "Playful Strokes",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4896b02e17ea42c5f189/xxs",
    },
    {
        name: "Warm Endeavors",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/438fb0e059a12d2676b9/xxs",
    },
    {
        name: "Cyan Essence",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4049b05a36a545a7540f/xxs",
    },
    {
        name: "Stochastic Splash",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4d0daab197533da468c8/xxs",
    },
    {
        name: "Sharp Teal",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4b21a4f419bac75dc110/xxs",
    },
    {
        name: "Nature's Tales",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/W5SgTAApH8pQ6mxnbt2iPu9jx0WL8rmc/xxs",
    },
    {
        name: "Urban Observations",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/2wBE53qhwIVZAZ3Ob_XbnJ1-E5olCFIP/xxs",
    },
    {
        name: "Fantasy Visions",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/BMBtuwQD0AugOEEYeihGM0qo9s4mxCk2/xxs",
    },
    {
        name: "Corporate Memphis",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/RqgrSkpqPpqN9kPqMdXc-_EmnhRZLbs5/xxs",
    },
    {
        name: "Dotted Dimensions",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/47NYe2HAi-oYqJRtIVtoDURwQ400tRlF/xxs",
    },
    {
        name: "Timeless Tales",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/g3MQ9wlPKTGwQLKAgF8DeX2ZGaEF93GR/xxs",
    },
    {
        name: "Scribbled Stories",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/BE8v7P6NxPFkU6xvMejjvBrkCsIJqBE_/xxs",
    },
    {
        name: "Liquid Elegance",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/7Hin0C-ImZx4jSehmkl_R2pN2ZFMGELW/xxs",
    },
    {
        name: "Vivid Folklore",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/0DVuHQOVfn9X3hvhJeQ4qqYUHtUdrXRe/xxs",
    },
    {
        name: "Enchanted Sketches",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/YRwV6eTT9wNI6ajP1T8qs5WbdvIVXZIE/xxs",
    },
    {
        name: "Modern Musings",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/DNOMjcG0nc4TAcCCJGe4Oze8YEsEEbWu/xxs",
    },
    {
        name: "Wild Imaginations",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/KrnJia3bsRqRItK7ENqY_VWaPw55Ljwl/xxs",
    },
    {
        name: "Witty Watercolors",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/_qOBCY_gVTxF6so5HP5PTYFZAPNzziBE/xxs",
    },
    {
        name: "Fjord Fantasies",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/7s2Rsy5jbEaUKngo6MHu8SAePkDq8gcv/xxs",
    },
    {
        name: "Dark Dreamscapes",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/3Fn1UXomVpzyIOaireOSblPOUtCFb4LG/xxs",
    },
    {
        name: "Vibrant Collisions",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/bNmozNipMHUT5MOA43JqdfyVgQydW9M1/xxs",
    },
    {
        name: "Cubist Kaleidoscope",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/nnEwqsfTsXnZCgB6QYqm-7jnH8e06nP3/xxs",
    },
    {
        name: "Environment Concepts",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/DvstafsOVoFEd4YZSNRl1Olk1pv3mB_i/xxs",
    },
    {
        name: "Melancholic Magic",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/UjZ5TmFy_j6HL6edtwxGSdYVshzsgxmV/xxs",
    },
    {
        name: "Retro Reveries",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/hZlM3nezyETMZUdwrHEDvkWENTCYQKEO/xxs",
    },
    {
        name: "Serene Sceneries",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/8omdpLtzopVFBXHm1AZcoOd3dlb2P9gb/xxs",
    },
    {
        name: "Pastel Portals",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/OJOmqM7xwA9Gr2niDJopX4m2nB79iWcF/xxs",
    },
    {
        name: "Radiant Rhythms",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/J_-C092CBCbWUEmsRTvzaAI2NJ1VFaPY/xxs",
    },
    {
        name: "Graphic Grit",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/z_6aWDzXrzehzFd29D4HMP7uM6q4l7jy/xxs",
    },
    {
        name: "Whimsical Wonders",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/-i-XEiWjYUodJEl1I1x0xxDs-289QxYN/xxs",
    },
    {
        name: "Geometric Grace",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/XJydbycU-FD1TUfYQojDaQNE3ndNUK2E/xxs",
    },
    {
        name: "Abstract Aria",
        image: "https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/4ZmoHvQU067i37TLK7xM5zQg-dhq6E6r/xxs",
    },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

function ModeItem(props) {
    return (
        <div
            ref={props.selected ? props.selectedRef : null}
            onClick={() => props.onSelect()}
            className={classNames(
                "group shadow rounded-lg relative flex items-center overflow-hidden flex-col cursor-pointer border dark:border-gray-600 dark:hover:border-gray-500 m-2 w-32 sm:w-36 h-32 text-xs text-center hover:border-secondary transition-all duration-200",
                props.selected
                    ? "bg-secondary-extralight border-secondary-dark dark:bg-gray-800 dark:border-secondary dark:hover:border-secondary"
                    : "dark:bg-gray-600"
            )}
        >
            <div className="absolute h-24 overflow-hidden flex items-center justify-center w-full">
                <div className="h-8 w-8 dark:fill-gray-100 fill-back text-black dark:text-gray-300 transition-transform duration-200 group-hover:scale-110">
                    {props.image}
                </div>
            </div>
            <div className="absolute bottom-0 my-2 text-gray-800 dark:text-gray-100 font-semibold">
                {props.name}
            </div>
        </div>
    );
}

function CollectionSelectorItem(props) {
    return (
        <div
            ref={props.selected ? props.selectedRef : null}
            onClick={() => props.onSelect()}
            className={classNames(
                "group shadow relative flex items-center overflow-hidden flex-col cursor-pointer border dark:border-gray-600 dark:hover:border-gray-500 rounded-lg m-2 w-32 sm:w-36 h-32 text-xs text-center hover:border-secondary transition-all duration-200",
                props.selected
                    ? "bg-secondary-extralight border-secondary-dark dark:bg-gray-800 dark:border-secondary dark:hover:border-secondary"
                    : ""
            )}
        >
            <div className="absolute h-24 overflow-hidden">
                <img
                    src={props.image}
                    alt={props.name}
                    className="-mt-2 w-36 h-36 transition-transform duration-200 group-hover:scale-110"
                />
            </div>
            <div className="absolute bottom-0 my-2 text-gray-800 dark:text-gray-100 ">
                {props.name}
            </div>
        </div>
    );
}

function CollectionSelector(props) {
    const scrollContainerRef = useRef(null);
    const selectedItemRef = useRef(null);
    const [userHasInteracted, setUserHasInteracted] = useState(false);

    // Create combined options with type information
    const allOptions = [
        ...modes.map((mode) => ({ ...mode, type: "mode" })),
        ...collections.map((collection) => ({
            ...collection,
            type: "collection",
        })),
    ];

    const [selected, setSelected] = useState(() => {
        if (props.initialCollection) {
            return (
                allOptions.find(
                    (option) =>
                        option.type === "collection" &&
                        option.name === props.initialCollection
                ) || allOptions[0]
            );
        }
        if (props.initialMode) {
            return (
                allOptions.find(
                    (option) => option.type === "mode" && option.name === props.initialMode
                ) || allOptions[0]
            );
        }
        return allOptions[0];
    });

    console.log(selected);

    // Reset user interaction flag when dialog opens
    useEffect(() => {
        if (props.open) {
            setUserHasInteracted(false);
        }
    }, [props.open]);

    // Scroll to selected item only when dialog first opens, not after user clicks
    useEffect(() => {
        if (props.open && !userHasInteracted && selectedItemRef.current && scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const selectedElement = selectedItemRef.current;
            
            const containerRect = container.getBoundingClientRect();
            const elementRect = selectedElement.getBoundingClientRect();
            
            const isVisible = 
                elementRect.top >= containerRect.top &&
                elementRect.bottom <= containerRect.bottom;
            
            if (!isVisible) {
                selectedElement.scrollIntoView({
                    behavior: 'instant',
                    block: 'start'
                });
            }
        }
    }, [props.open, selected, userHasInteracted]);

    return (
        <Transition.Root show={props.open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={props.setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 dark:bg-gray-950 dark:bg-opacity-75 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen sm:my-16">
                    <div className="flex min-h-full items-end h-full justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform h-full flex flex-col overflow-hidden rounded-lg bg-white px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[45rem] sm:p-6 sm:pt-4 dark:bg-gray-700">
                                <div className="mb-4">
                                    <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
                                        Select Style
                                    </h3>
                                </div>

                                <div 
                                    ref={scrollContainerRef} 
                                    className="w-full h-full overflow-x-hidden overflow-y-auto flex-1 mb-4"
                                    style={{
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: 'rgb(156 163 175) transparent',
                                        WebkitScrollbarWidth: 'thin'
                                    }}
                                    
                                >
                                    {/* Modes Section */}
                                    <div className="mb-6">
                                        {/* <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-3">
                                            Modes
                                        </h4> */}
                                        <div className="flex flex-wrap justify-center sm:justify-start">
                                            {modes.map((mode) => (
                                                <ModeItem
                                                    {...mode}
                                                    key={mode.name}
                                                    selected={selected?.name === mode.name}
                                                    selectedRef={selected?.name === mode.name ? selectedItemRef : null}
                                                    onSelect={() => {
                                                        setUserHasInteracted(true);
                                                        setSelected({
                                                            ...mode,
                                                            type: "mode",
                                                        })
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>

                                    {/* Collections Section */}
                                    <div>
                                        {/* <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-3">
                                            Illustrations
                                        </h4> */}
                                        <div className="flex flex-wrap justify-center sm:justify-start">
                                            {collections.map((collection) => (
                                                <CollectionSelectorItem
                                                    {...collection}
                                                    key={collection.name}
                                                    selected={
                                                        selected?.type === "collection" &&
                                                        selected?.name === collection.name
                                                    }
                                                    selectedRef={
                                                        selected?.type === "collection" &&
                                                        selected?.name === collection.name
                                                            ? selectedItemRef
                                                            : null
                                                    }
                                                    onSelect={() => {
                                                        setUserHasInteracted(true);
                                                        setSelected({
                                                            ...collection,
                                                            type: "collection",
                                                        })
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4 sm:mt-1">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-secondary-dark px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-secondary-darkest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        onClick={() => {
                                            props.setOpen(false);
                                            props.setSelected(selected);
                                            window.umami?.track(
                                                "Create Mode Button - Select style",
                                                {
                                                    type: selected.type,
                                                    name: selected.name,
                                                }
                                            );
                                        }}
                                    >
                                        Select
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default function CreateModeButton(props) {
    const [selected, setSelected] = useState(() => {
        if (props.initialMode && props.initialAuxMode) {
            return {
                name: props.initialMode,
                collectionName: props.initialAuxMode,
                type: "collection",
            };
        } else if (props.initialMode) {
            const mode = modes.find((mode) => mode.name === props.initialMode);
            return mode
                ? { ...mode, type: "mode" }
                : { ...modes[0], type: "mode" };
        }
        return { ...modes[0], type: "mode" };
    });

    const [showCollectionOptions, setShowCollectionOptions] = useState(false);

    return (
        <Listbox
            value={selected}
            disabled={props.disabled}
            onChange={(value) => {
                setSelected(value);
                props.onSetMode?.(value?.name);
            }}
        >
            {({ open }) => (
                <>
                    <div
                        className={classNames(
                            "relative",
                            selected?.name === "collection" ? "w-56" : "w-40"
                        )}
                        title="Select a style"
                    >
                        <Listbox.Button
                            disabled={props.disabled}
                            onClick={(e) => {
                                setShowCollectionOptions(true);
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                            className="dark:fill-gray-100 relative w-full cursor-default rounded-md hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600 dark:ring-gray-600 dark:disabled:bg-gray-700 dark:disabled:text-gray-400 disabled:bg-gray-100 bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6"
                        >
                            <span className="flex items-center">
                                <span className="h-4 w-4 flex-shrink-0">
                                    {selected?.type === "collection" ? (
                                        <RectangleStackIcon />
                                    ) : (
                                        selected.image
                                    )}
                                </span>
                                <span className="ml-3 block truncate">
                                    {selected?.type === "collection"
                                        ? selected.collectionName
                                        : selected.name}
                                </span>
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                <ChevronUpDownIcon
                                    className="h-5 w-5 dark:text-gray-400"
                                    aria-hidden="true"
                                />
                            </span>
                        </Listbox.Button>

                        {showCollectionOptions && (
                            <CollectionSelector
                                initialCollection={selected?.collectionName}
                                initialMode={selected?.name}
                                setSelected={(collection) => {
                                    if (collection.type === "collection") {
                                        setSelected({
                                            name: "collection",
                                            type: "collection",
                                            collectionName: collection.name,
                                        });
                                        props.onSetMode?.(
                                            "collection",
                                            collection.name
                                        );
                                    } else {
                                        setSelected({
                                            image: collection.image,
                                            name: collection.name,
                                            type: "mode",
                                        });
                                        props.onSetMode?.(collection.name);
                                    }
                                }}
                                open={showCollectionOptions}
                                setOpen={setShowCollectionOptions}
                            />
                        )}
                    </div>
                </>
            )}
        </Listbox>
    );
}
